import { StudyMilestoneDates } from './StudyMilestones';

interface Study {
  studySk: string;
  clientName: string;
  protocolNumber: string;
  bcNumber: string;
  ppdRegion: string;
  studyPhase: string;
  studyPhaseSimpleLabel: string;
  studyPhaseSortOrder: string;
  studyStatus: string;
  country: string;
  sitesActivated: string;
  subjectsEnrolled: string;
  therapeuticArea: string;
  indication: string;
  region: string;
  studyHealthScore: string;
  spendToBudgetScore: string;
  nextMilestone: string;
  milestoneStatus: PortfolioMilestoneStatus;
  accelerator: string;
  fspIndicator: string;
  studyStage: string;
  drugName: string;
  kpis: StudyKpi[];
  kpiActive: number | undefined;
  kpiEnrolled: number | undefined;
  countryList?: string[];
  ppdRegionList?: string[];
  regionList?: string[];
  protocolDesc: string;
  // Optional; some portfolio rows may not include milestone date details.
  milestoneDates?: StudyMilestoneDates;
}

enum PortfolioMilestoneStatus {
  Upcoming = 'Upcoming',
  OnTrack = 'On Track',
  AtRisk = 'At Risk',
  PastDue = 'Past Due',
  DatesNotAvailable = 'Dates Not Available'
}
interface StudyKpi {
  kpiName: string;
  value: number | undefined | null;
  type: string;
}

export { PortfolioMilestoneStatus };
export type { Study, StudyKpi };
